module.exports = __webpack_public_path__ + "static/media/ic-arrow-right.3ef11e31.svg";